import { GridActionsCellItem } from '@mui/x-data-grid-pro'
import { TFunction } from 'i18next'
import { MdDelete, MdEdit, MdSwapHoriz, MdUndo } from 'react-icons/md'
import { IVesselDisplayRow } from './vesselSuccession'

export const buildVesselRowActions = ({
  row,
  translate,
  onReplace,
  onEdit,
  onRevert,
  onDelete,
}: {
  row: IVesselDisplayRow
  translate: TFunction
  onReplace?: (row: IVesselDisplayRow) => void
  onEdit?: (row: IVesselDisplayRow) => void
  onRevert?: (row: IVesselDisplayRow) => void
  onDelete?: (row: IVesselDisplayRow) => void
}): JSX.Element[] => {
  if (row.isReplaced) {
    return [
      <GridActionsCellItem
        key={'edit'}
        label={translate('edit', { ns: 'common' })}
        icon={<MdEdit size={20} />}
        onClick={() => onEdit?.(row)}
        disabled={!row.canEdit}
        color="primary"
      />,
    ]
  }

  const actions: JSX.Element[] = []

  if (row.canReplace) {
    actions.push(
      <GridActionsCellItem
        key={'replace'}
        label={translate('replace-vessel', { ns: 'task' })}
        icon={<MdSwapHoriz size={24} />}
        onClick={() => onReplace?.(row)}
        color="primary"
        showInMenu
      />,
    )
  }

  if (row.canEdit) {
    actions.push(
      <GridActionsCellItem
        key={'edit'}
        label={translate('edit', { ns: 'common' })}
        icon={<MdEdit size={24} />}
        onClick={() => onEdit?.(row)}
        color="primary"
        showInMenu
      />,
    )
  }

  if (row.canRevert) {
    actions.push(
      <GridActionsCellItem
        key={'revert'}
        label={translate('revert-vessel', { ns: 'task' })}
        icon={<MdUndo size={24} />}
        onClick={() => onRevert?.(row)}
        color="primary"
        showInMenu
      />,
    )
  }

  if (row.canDelete) {
    actions.push(
      <GridActionsCellItem
        key={'delete'}
        label={translate('delete', { ns: 'common' })}
        icon={<MdDelete size={24} />}
        onClick={() => onDelete?.(row)}
        color="primary"
        showInMenu
      />,
    )
  }

  return actions
}
